
			<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container">

          <a routerLink="/principal" class="navbar-brand"><img src="assets/images/lhb.png" alt="homepage" class="light-logo" />
            <img src="assets/images/lhtextow.png" class="light-logo" alt="homepage" /></a>

          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">

              <ul class="navbar-nav ml-auto">

                      <li class="nav-item dropdown"  *ngIf="estaLogueado" >
                      <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="#" id="navbarDropdown" role="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Inicio
                      </a>
                      <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                          <a class="dropdown-item" href="/#/dashboard">Inicio</a>
                          <div class="dropdown-divider"></div>
                          <a (click)="_usuarioService.logout()" class="dropdown-item pointer" >Salir</a>
                      </div>
                  </li>

                   <li class="nav-item active" *ngIf="!estaLogueado" >
                      <a class="nav-link" href="/#/login">Iniciar Sesión <span class="sr-only">(current)</span></a>
                  </li>

                  <li class="nav-item" *ngIf="!estaLogueado">
                      <a class="nav-link" href="/#/registro">Registrarse</a>
                  </li>
              </ul>
          </div>
      </div>
      </nav>

<body>

  <div class="bbb_deals_featured">
  <div class="container">
      <div class="row">
        <div class="col d-flex flex-lg-row flex-column align-items-center justify-content-center">
          <!-- bbb_deals -->
          <div class="bbb_deals">

            <div class="alert alert-info" *ngIf="inmueble.imagen.length === 0" >
              No hay resultados de la búsqueda
          </div>

            <div class="bbb_deals_slider_container">
              <button (click)="regresarPagina()" style="width: 100px; height: 40px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
              <!-- bbb_deals Item -->
              <div class=" bbb_deals_item">
                <div style="font-size: 20px;" align="center" class="bbb_deals_item_category"><b>{{inmueble.tipo}}</b></div>
                <div class="p-carousel">
                  <div class="carousel slide" data-ride="carousel" id="{{inmueble._id}}">
                    <div class="carousel-inner" role="listbox">
                      <div  *ngFor="let avatar of inmueble.imagen; let i = index" class="carousel-item"
                        [ngClass]="{'active': i===0}">
                        <img style="width:310px; height:310px" [src]='avatar.url' class="img-responsive image">
                      </div>
                      <img *ngIf="inmueble.imagen.length===0" style="width:100%; height:100%" src="../../assets/images/notinmueble.png" class="img-responsive image">
                    </div>

                    <div>
                      <a class="carousel-control-prev" href="#{{inmueble._id}}" role="button" data-slide="prev"><span
                          class="carousel-control-prev-icon"></span>
                        <span class="sr-only">Previous</span></a><a class="carousel-control-next" href="#{{inmueble._id}}"
                        role="button" data-slide="next"><span class="carousel-control-next-icon"></span><span
                          class="sr-only">Next</span></a>
                    </div>
                  </div>
                </div>
                <br>
                <div class="bbb_deals_info_line d-flex flex-row justify-content-start">

                  <div class="bbb_deals_item_price_a ml-auto"
                    [ngStyle]="{'background-color':inmueble.estado == 'DISPONIBLE' ? '#007bff':'#fc4b6c'}">
                    <b>{{inmueble.estado}}</b></div>
                </div>
                <hr>
                <div class="bbb_deals_content">
                  <div class="bbb_deals_info_line d-flex flex-row justify-content-start">
                    <div class="bbb_deals_item_name">{{inmueble.nombre}}</div>
                    <div class="bbb_deals_item_price ml-auto">${{inmueble.precioalquiler}}</div>
                  </div>
                  <div class="available">
                    <div class="bbb_deals_item_category">Código del inmueble:</div>
                    <div class="available_title">{{inmueble.codigo}}</div>
                    <br>
                    <div class="bbb_deals_item_category">Dirección:</div>
                    <div class="available_title">{{inmueble.direccion}}</div>
                    <br>
                    <div class="bbb_deals_item_category">Servicios incluidos:</div>
                    <div class="available_title">{{inmueble.servicio}}</div>
                    <br>
                    <div class="bbb_deals_item_category">Descripción:</div>
                    <div class="available_title">{{inmueble.descripcion}}</div>
                    <div class="available_bar"><span style="width:17%"></span></div>
                  </div>
                  <br>
                  <button *ngIf="rolUsuario"  (click)="logueado()" [routerLink]="['/crearvisita', inmueble._id]"
                    class="btn btn-block btn-primary"><abbr title="Ver inmueble"></abbr>Solicitar Visita</button>
                </div>
              </div>
            </div>

          </div> <!-- Featured -->
        </div>
      </div>
    </div>
    <br>
    <br>
  </div>

</body>

<div class="footer-dark">
  <footer>
      <div class="container">
          <div class="row">
              <div class="col-md-5 item">
                  <h3>Enlaces útiles</h3>
                  <ul>
                    <li><a href="/#/login">Inicia Sesión</a></li>
                    <li><a href="/#/registro">Regístrate</a></li>
                  </ul>
              </div>
              <div class="col-md-5 item">
                  <h3>Contacto</h3>
                  <ul>
                      <li><a href="#">Loja, Loja-Ecuador</a></li>
                      <li><a href="/#/enviarmensaje">Contáctanos</a></li>
                      <li><a href="#">0989994545</a></li>
                  </ul>
              </div>

              <div class="col item social"><a href="#"><i class="fa fa-facebook"></i></a>
                                           <a href="#"><i class="fa fa-youtube"></i></a>
                                           <a href="#"><i class="fa fa-instagram"></i></a>
                                           <a href="#"><i class="fa fa-google"></i></a></div>
          </div>
          <br>
          <p class="copyright">lojahouse.com © 2020</p>
      </div>
  </footer>
